import locales from "@/i18n/locals.json";
import en from "./en.json";

export default {
  [locales.ENGLISH]: { ...en },
};
